import { WishlistLineItem } from '@api/types';
import { useWishlist } from '@hooks';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import StarIcon from '@mui/icons-material/Star';
import StarOutlineIcon from '@mui/icons-material/StarOutline';
import { Box, IconButton, SxProps, styled } from '@mui/material';
import { colors } from '@themes/colors';

const StarWrapper = styled(Box)`
  color: ${colors.primary.mainGreen};
`;

type WishlistToggleProps = {
  code: string;
  sx?: SxProps;
  hasRemoveIcon?: boolean;
  name?: string;
};

export const WishlistToggle = ({ code, sx, hasRemoveIcon, name }: WishlistToggleProps) => {
  const {
    addToWishlistHandler,
    removeFromWishlistHandler,
    addResponse,
    removeResponse,
    wishlist,
    getWishlistStatus,
  } = useWishlist();
  const { isFetching, isLoading } = getWishlistStatus;
  const isWorking = isFetching || isLoading;
  const isInWishlist = wishlist?.some(
    (wishlistItem: WishlistLineItem) => wishlistItem.code === code
  );
  return (
    <StarWrapper sx={sx}>
      {isInWishlist ? (
        <IconButton
          aria-label='remove from favorites'
          color='inherit'
          onClick={() => removeFromWishlistHandler(code, name)}
          disabled={addResponse.isLoading && isWorking}
        >
          {hasRemoveIcon ? (
            <DeleteOutlineIcon sx={{ fontSize: 24 }} />
          ) : (
            <StarIcon sx={{ fontSize: 32 }} />
          )}
        </IconButton>
      ) : (
        <IconButton
          aria-label='add to favorites'
          color='inherit'
          onClick={() => addToWishlistHandler(code, name)}
          disabled={removeResponse.isLoading && isWorking}
        >
          <StarOutlineIcon sx={{ fontSize: 32 }} />
        </IconButton>
      )}
    </StarWrapper>
  );
};
